import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import Loader from '../../assets/tools/Loder/loader';
import { FormActions } from '../../componants/Workspace';
import LocationPicker from './LocationPicker';

const EditConferences = () => {
  const { SetNotification } = useStateContext();
  const { id } = useParams(); 
  const navigate = useNavigate();

  // Refs for form fields
  const titleArRef = useRef(null);
  const titleEnRef = useRef(null);
  const sloganArRef = useRef(null);
  const sloganEnRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const locationNameRef = useRef(null);
  const latitudeRef = useRef(null);
  const longitudeRef = useRef(null);
  const logoRef = useRef(null);
  const locationarNameRef = useRef(null) ; 
  const [isSending, setIsSending] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [showModal, setShowModal] = useState(false); 
  const [showLocationPicker, setShowLocationPicker] = useState(false);
  const [loading, setIsloading] = useState(true);

  useEffect(() => {
    const fetchConferenceData = async () => {
      try {
        const response = await AxiosClient.get(`/conferences/${id}`);
        setInitialData(response.data);
      } catch (error) {
        console.error('Error fetching conference data:', error);
      } finally {
        setIsloading(false);
      }
    };

    if (id) {
      fetchConferenceData();
    }
  }, [id]);

  useEffect(() => {
    if (initialData) {
      titleArRef.current.value = initialData.ar_title || '';
      titleEnRef.current.value = initialData.en_title || '';
      sloganArRef.current.value = initialData.ar_slogan || '';
      sloganEnRef.current.value = initialData.en_slogan || '';
      startDateRef.current.value = initialData.start_date ? new Date(initialData.start_date).toISOString().slice(0, -1) : '';
      endDateRef.current.value = initialData.end_date ? new Date(initialData.end_date).toISOString().slice(0, -1) : '';
      locationNameRef.current.value = initialData.location_name || '';
      locationarNameRef.current.value = initialData.ar_location_name || '';

      latitudeRef.current.value = initialData.latitude || '';
      longitudeRef.current.value = initialData.longitude || '';
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData();
    formData.append('ar_title', titleArRef.current.value);
    formData.append('en_title', titleEnRef.current.value);
    formData.append('ar_slogan', sloganArRef.current.value);
    formData.append('en_slogan', sloganEnRef.current.value);
    formData.append('start_date', startDateRef.current.value);
    formData.append('end_date', endDateRef.current.value);
    formData.append('location_name', locationNameRef.current.value);
    formData.append('ar_location_name', locationarNameRef.current.value);

    formData.append('latitude', latitudeRef.current.value);
    formData.append('longitude', longitudeRef.current.value);
    
    if (logoRef.current.files[0]) {
      formData.append('logo', logoRef.current.files[0]); 
    }

    try {
      await AxiosClient.post(`/conferences/${id}`, formData);
      SetNotification('Conference updated successfully', 'success');
      navigate(-1);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'An error occurred while updating the conference.';
      SetNotification(errorMessage, 'danger');
    }
    setIsSending(false);
  };

  const handleDelete = async () => {
    try {
      await AxiosClient.delete(`/conferences/${id}`);
      SetNotification('Conference deleted successfully', 'success');
      navigate('/conference');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'An error occurred while deleting the conference.';
      SetNotification(errorMessage, 'danger');
    }
    setShowModal(false);
  };

  if (loading) {
    return <Loader label="Loading conference details..." />;
  }

  return (
    <div className="m-4">
      <form className="form-group" onSubmit={handleSubmit}>
        <h5>عنوان المؤتمر باللغة العربية</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Arabic title" ref={titleArRef} />
        </div>

        <h5>Conference Title in English</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter English title" ref={titleEnRef} />
        </div>

        <h5>شعار المؤتمر باللغة العربية</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Arabic slogan" ref={sloganArRef} />
        </div>

        <h5>Conference Slogan in English</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter English slogan" ref={sloganEnRef} />
        </div>

        <h5>Start Date</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={startDateRef} />
        </div>

        <h5>End Date</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={endDateRef} />
        </div>

        <h5> English Location Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter location" ref={locationNameRef} />
        </div>
        
        <h5> Arabic Location Name</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter location" ref={locationarNameRef} />
        </div>

        <h5>Latitude</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="number" className="form-control" placeholder="Enter latitude" ref={latitudeRef} step="any" min="-90" max="90" />
        </div>

        <h5>Longitude</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="number" className="form-control" placeholder="Enter longitude" ref={longitudeRef} step="any" min="-180" max="180" />
        </div>
        <button type="button" className="btn btn-outline-info mb-3" onClick={() => setShowLocationPicker(true)}>
          Set location on map
        </button>

        <h5>Logo</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="file" className="form-control" ref={logoRef} accept="image/*" />
        </div>

        <hr className="border-gray-300 my-4" />

        <FormActions>
          {isSending ? <span role="status">Saving conference...</span> : (
          <button type="submit" className="btn btn-info m-2">
            Save changes
          </button>
          )}
          <button type="button" className="btn btn-outline-danger" onClick={() => setShowModal(true)}>
            Delete conference
          </button>
        </FormActions>
      </form>

      {showLocationPicker && (
        <LocationPicker
          address={locationNameRef.current?.value || ''}
          latitude={latitudeRef.current?.value || ''}
          longitude={longitudeRef.current?.value || ''}
          onClose={() => setShowLocationPicker(false)}
          onSelect={(latitude, longitude) => {
            latitudeRef.current.value = latitude.toFixed(6);
            longitudeRef.current.value = longitude.toFixed(6);
          }}
        />
      )}

      {showModal && (
        <div className="modal show" style={{ display: 'block' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Are you sure?</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this conference? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={handleDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditConferences;
